import { dialog } from "nq-component";
import BaseFormPresenter from "../../base/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../usecases/object";

class OthersPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    this.getObject();
    this.findOthers();
  }

  async findOthers() {
    const response = await findObjectUseCase().execute("others");
    console.log("response", response);
    this.view.setState({ others: response });
  }

  async handleSubmit(object, others) {
    dialog.close();
    const queueObject = {
      name: `${object.firstName} ${object.lastName}`,
      status: "waiting",
      window: object?.name,
    };

    // delete object.firstName;
    // delete object.lastName;
    // delete object.updated;
    // delete object.created;
    // delete object.id;
    // delete object.acl;
    // console.log("others", object);
    try {
      await upsertUseCase().execute("queue", queueObject);
      this.view.submissionSuccess();
      this.view.showSuccessSnackbar("Successfully saved!");
    } catch (error) {
      throw error;
    }
  }
}

export default OthersPresenter;
